"use client"
import React, { useState, useEffect, useCallback } from "react";
import "@/components/locator/LocatorSearchMenu.css";
import { useFuzzySearchList } from "@nozbe/microfuzz/react";
import useApi from "@/components/api/useApi";

const LocatorSearchMenu = ({
  searchOptions,
  show,
  searchText,
  onSelect,
  showTextSearch = false,
  crm = false
}) => {
  // console.log("LocatorSearchMenu searchOptions", searchOptions);
  const nullSearchTermsCount =
    searchOptions?.filter(option => option.searchTerms == null).length || 0;
  // console.log("Options with null searchTerms:", nullSearchTermsCount);

  const [searchTextState, setSearchTextState] = useState("");
  const [randomNumber, setRandomNumber] = useState(0);

  const api = useApi();

  useEffect(() => {
    const handler = setTimeout(() => {
      setSearchTextState(searchText);
    }, 500); // wait 500ms after user stops typing

    // Cleanup the timeout if inputValue changes again
    return () => {
      clearTimeout(handler);
    };
  }, [searchText]);

  useEffect(() => {
    setRandomNumber(api.getRandomInt(10000, 99999));
  }, [searchTextState]);

  const searchResults = useFuzzySearchList({
    list: searchOptions,
    queryText: searchTextState,
    getText: item => item?.searchTerms,
    mapResultItem: item => item,
    strategy: "smart"
  });

  const objectLabelMap = {
    BUSINESS: "Businesses",
    VENDOR: "Vendors",
    PROPERTY: "Properties",
    SERVICE: "Categories"
  };

  // console.log("searchResults", searchResults);

  return (
    <ul
      key="locator-search-menu"
      className={`locator-search-menu ${show ? "show" : ""}`}
    >
      {showTextSearch && searchTextState.length > 0 && (
        <li
          key={`text-search-${randomNumber}`}
          onClick={() =>
            onSelect({ searchType: "TEXT", value: searchTextState })
          }
        >
          <div key={`text-search-${randomNumber}-icon`}>
            <i className="fa-solid fa-magnifying-glass" />
          </div>
          <span>Search for '{searchTextState}'</span>
        </li>
      )}
      {searchResults.length !== searchOptions.length && (
        <>
          {searchResults.map(result => {
            // console.log("result", result);
            let groupLabel = null;
            let objectLabel = null;
            if (result.item?.objectLabel) {
              objectLabel = result.item.objectLabel;
            } else if (result.item?.type) {
              objectLabel = objectLabelMap[result.item?.type];
            }
            if (result.item?.group) {
              if (crm) {
                const group = searchOptions.find(
                  option => option.value?.value === result.item.group
                );
                groupLabel = group?.label;
              } else {
                const group = searchOptions.find(
                  option => option.value === result.item.group
                );
                groupLabel = group?.label;
              }
            }
            return (
              <li
                key={result.item?.value}
                id={result.item?.value}
                onClick={() => onSelect(result.item)}
              >
                {!result.item?.group && result.item?.icon ? (
                  <div
                    key={`${result.item?.value}-icon-${randomNumber}`}
                    className="icon-container"
                  >
                    <i className={`fa-solid fa-${result.item?.icon}`} />
                  </div>
                ) : (
                  <div
                    key={`${result.item?.value}-icon-${randomNumber}`}
                    className="icon-container"
                  >
                    <i className="fa-solid fa-magnifying-glass" />
                  </div>
                )}
                <div>
                  {objectLabel && !groupLabel && (
                    <span
                      key={`${result.item?.value}-object-label`}
                      className="group-label"
                    >
                      {objectLabel}
                    </span>
                  )}
                  {groupLabel && (
                    <span
                      key={`${result.item?.value}-group-label`}
                      className="group-label"
                    >
                      {groupLabel}
                    </span>
                  )}
                  <span
                    key={`${result.item?.value}-item-label`}
                    className="item-label"
                  >
                    {result.item?.label}
                  </span>
                </div>
              </li>
            );
          })}
        </>
      )}
    </ul>
  );
};
export default LocatorSearchMenu;
